import * as React from 'react';

const HomeTablet = ({ width, height }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.0534 3.48832C12.8579 2.50389 11.1421 2.50389 9.94661 3.48832L4.94661 7.6055C4.1904 8.22819 3.75 9.16221 3.75 10.1503V17.9668C3.75 19.7859 5.2109 21.25 7 21.25H7.25V18C7.25 15.3766 9.37665 13.25 12 13.25C14.6234 13.25 16.75 15.3766 16.75 18V21.25H17C18.7891 21.25 20.25 19.7859 20.25 17.9668V10.1503C20.25 9.16221 19.8096 8.22818 19.0534 7.6055L14.0534 3.48832ZM15.25 21.25V18C15.25 16.2051 13.7949 14.75 12 14.75C10.2051 14.75 8.75 16.2051 8.75 18V21.25H15.25ZM8.99311 2.33037C10.7425 0.889878 13.2575 0.889874 15.0069 2.33037L20.0069 6.44755C21.1111 7.35681 21.75 8.71654 21.75 10.1503V17.9668C21.75 20.6027 19.6292 22.75 17 22.75H7C4.37082 22.75 2.25 20.6027 2.25 17.9668V10.1503C2.25 8.71654 2.88889 7.35681 3.99311 6.44755L8.99311 2.33037Z'
      fill='white'
    />
  </svg>
);

export default HomeTablet;
